module.exports = __webpack_public_path__ + "static/media/Link.f829e57b.jpg";